
(function userDetailControllerDefinition() {
    'use strict';
    angular.module('ProcessBatch')
        .controller('ProcessBatchDetailController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'processBatchService', '$stateParams',
            function processBatchDetailController($scope, config, $state, $translate, errors, processBatchService, $stateParams) {
                $scope.data = {
                    currentPage: 1,
                    totalItems: 0,
                    itemsPerPage: 15,
                    from: 0,
                    orderAsc: true
                };

                $translate(['ProcessBatchDetail']).then(function (translated) {
                    $scope.title = translated.ProcessBatchDetail;
                });

                $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                    .then(function (translated) {
                        $scope.paginatorTranslations = {
                            nextText: translated.PaginationNext,
                            previousText: translated.PaginationPrev,
                            lastText: translated.PaginationLastFem,
                            firstText: translated.PaginationFirstFem
                        };
                    });

                processBatchService.getById($stateParams.id).then(function (result) {
                    $scope.process = result;
                    $scope.getHistory();
                }, function (error) {
                    errors.showError(error);
                    $state.go('process-batch-find');
                });

                $scope.sortColumn = function () {
                    $scope.data.orderAsc = !$scope.data.orderAsc;
                    $scope.getHistory();
                };

                $scope.getHistory = function () {
                    var params = {
                        processId: $scope.process.id,
                        page: $scope.data.currentPage,
                        itemsPerPage: $scope.data.itemsPerPage,
                        orderBy: 'cd',
                        sortOrder: $scope.data.orderAsc ? 1 : -1
                    };

                    processBatchService.getHistory(params).then(function (result) {
                        if (result.success && result.value) {
                            $scope.process.logs = result.value.values;
                            $scope.data.totalItems = result.value.count;
                            $scope.data.from = 1 + ($scope.data.itemsPerPage * ($scope.data.currentPage - 1));
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go("process-batch-find");
                };
            }
        ]);
})();